import { useState, useEffect } from "react";
import { getFamily } from "../api-interactions/family";
import { BsPlusCircleFill } from "react-icons/bs";
import "./taskManagmentList.css";
import { getSingleList } from "../api-interactions/lists";
import { getCookie } from "../helperFunctions/cookie";
import { useNavigate } from "react-router-dom";

export const TaskManagerList = (props) => {
  const [acceptCount, setAcceptCount] = useState([]);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const getTodoList = async (member) => {
    const res = await getSingleList(getCookie(), member.todoLink);
    return res.data.list;
  };

  const navigateToPage = (i) => {
    props.setSelected(i);
  };

  useEffect(() => {
    (async function () {
      const members = await getFamily(user);
      members.forEach(async (member) => {
        const todoList = await getTodoList(member);
        const open = todoList.needAccept.filter(
          (item) => item.state === "open" && item.addedBy === user.userName
        );
        const accepted = todoList.needAccept.filter(
          (item) => item.state === "accepted" && item.addedBy === user.userName
        );
        const denied = todoList.needAccept.filter(
          (item) => item.state === "denied" && item.addedBy === user.userName
        );
        setAcceptCount((prevCount) => [
          ...prevCount,
          {
            open: open.length || 0,
            accepted: accepted.length || 0,
            denied: denied.length,
            raw: todoList,
          },
        ]);
      });
      setMembers(members);
    })();
    setLoading(false);
  }, []);

  return (
    <div className="wide-list-container task-managment-list-container">
      <h2>Task Managment</h2>
      <div id="task-managment-inner">
        <div id="members-settings-container">
          {members.map((member, i) => {
            return (
              <div
                className="member hover"
                key={i}
                onClick={() => navigateToPage(i)}
              >
                {props.selected === i && (
                  <div
                    style={{ backgroundColor: member.color }}
                    className="selected-pill"
                  />
                )}
                <div
                  className="triangle"
                  style={{ borderLeft: "15px solid " + member.color }}
                ></div>
                <p>{member.userName}</p>
                {member.userName === user.userName && (
                  <span id="you-badge">YOU</span>
                )}
              </div>
            );
          })}
        </div>
        <div>
          {acceptCount.length === members.length &&
            members.map((member, i) => {
              return (
                <div className="other-options-task">
                  <BsPlusCircleFill
                    onClick={() => props.setQuickAdd(acceptCount[i].raw)}
                    className="add-btn"
                    style={{ marginRight: "2rem" }}
                  />
                  <span className="open-count">
                    {acceptCount[i].open} open -
                  </span>
                  <span className="accepted-count">
                    {acceptCount[i].accepted} accepted -
                  </span>
                  <span className="denied-count">
                    {acceptCount[i].denied} denied
                  </span>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};
